"use client";
import type { ReactElement } from "react";
import { motion, type MotionValue } from "framer-motion";
import { NODE_BLOOM_RING_SIZE, NODE_BREATHING_DURATION_S, NODE_BREATHING_SCALE, PERIOD_NODE_SIZE, TRANSITION_DURATION, } from "./timeline-constants";
import { type TimelineDotState, selectTimelineDotScale, selectTimelineDotVisual, selectTimelineNodeEntranceDelaySeconds, } from "./timeline-period-selectors";
export interface TimelinePeriodNodeProps {
    dotState: TimelineDotState;
    nodeCoreScale: MotionValue<number>;
    periodGlobalIndex: number;
    periodLabel: string;
    ringOpacity: MotionValue<number>;
    ringScale: MotionValue<number>;
    sectionColor: string;
    trackY: number;
}
export function TimelinePeriodNode({ dotState, nodeCoreScale, periodGlobalIndex, periodLabel, ringOpacity, ringScale, sectionColor, trackY, }: TimelinePeriodNodeProps): ReactElement {
    const dotVisual = selectTimelineDotVisual({ dotState });
    const dotScale = selectTimelineDotScale({ dotState, nodeCoreScale });
    return (<>
      <motion.div style={{
            position: "absolute",
            left: "50%",
            top: trackY,
            width: NODE_BLOOM_RING_SIZE,
            height: NODE_BLOOM_RING_SIZE,
            marginLeft: -NODE_BLOOM_RING_SIZE / 2,
            marginTop: -NODE_BLOOM_RING_SIZE / 2,
            borderRadius: "50%",
            border: `1px solid ${sectionColor}`,
            scale: ringScale,
            opacity: ringOpacity,
            pointerEvents: "none",
            zIndex: 4,
        }}/>

      <motion.div initial={{ opacity: 0, scale: 0 }} animate={{ opacity: 1, scale: 1 }} transition={{
            duration: 0.2,
            delay: selectTimelineNodeEntranceDelaySeconds({ periodGlobalIndex }),
            ease: "easeOut",
        }} style={{
            position: "absolute",
            left: "50%",
            top: trackY,
            width: PERIOD_NODE_SIZE,
            height: PERIOD_NODE_SIZE,
            marginLeft: -PERIOD_NODE_SIZE / 2,
            marginTop: -PERIOD_NODE_SIZE / 2,
            zIndex: 4,
        }}>
        <motion.div animate={{ scale: [1, NODE_BREATHING_SCALE, 1] }} transition={{
            duration: NODE_BREATHING_DURATION_S,
            ease: "easeInOut",
            repeat: Number.POSITIVE_INFINITY,
            delay: 1.5,
        }} style={{
            width: "100%",
            height: "100%",
        }}>
          <motion.div style={{
            width: "100%",
            height: "100%",
            borderRadius: "50%",
            backgroundColor: dotVisual.background,
            boxShadow: dotVisual.boxShadow,
            scale: dotScale,
            transition: `box-shadow ${TRANSITION_DURATION} ease-out, background ${TRANSITION_DURATION} ease-out`,
        }}/>
        </motion.div>
      </motion.div>
    </>);
}
